import { useUBL } from '@common/log-manager';
import { getUrl, PAGE_ID, TabType } from '@domains/pdp-common';

export const useTabsUBL = () => {
  const sendUBL = useUBL();

  const impressionSizeInfoTabUBL = async (isApp: boolean, catalog_product_id: string) => {
    const params = {
      category: 'impression' as const,
      navigation: 'product_detail',
      object_type: 'button',
      object_id: 'subtab_size',
    };

    sendUBL({
      ...params,
      ...(isApp && {
        navigation_sub: {
          page_url: getUrl(),
        },
      }),
      data: { catalog_product_id },
    });
  };

  const tabClickUBL = (catalog_product_id: string, tabType: TabType) => {
    sendUBL({
      category: 'click',
      navigation: 'product_detail',
      navigation_sub: {
        page_url: getUrl(),
      },
      object_section: 'subtab',
      object_type: 'button',
      object_id: `subtab_${PAGE_ID[tabType]}`,
      data: { catalog_product_id },
    });
  };

  return {
    impressionSizeInfoTabUBL,
    tabClickUBL,
  };
};
